import * as React from 'react';
import { useIntl } from 'react-intl';
import { FacebookIcon, FacebookShareButton, LinkedinIcon, LinkedinShareButton } from 'react-share';
import { formatMessageHelper } from '../../shared/helpers/internationalization';
import { addModifiers } from '../../shared/helpers';

import './SharingButtons.scss';

const INSTAGRAM_REEL_URL = 'https://www.instagram.com/reel/C4sl3pmP6uW/?igsh=NHg5a3pnejJ3dDhy';

// Instagram doesn't provide a way to share like Facebook or LinkedIn.
// I attempted to make an icon for Instagram combining with the gradient background using CSS
const InstagramIcon = () => (
  <svg viewBox="0 0 64 64" width={32} height={32} className={addModifiers('iqcSharingButtons__icon', ['instagram'])}>
    <path
      fill="#fff"
      d="M 32.4 16.6482 c 5.1232 0 5.7308 0.0192 7.7551 0.112 c 5.2032 0.2366 7.6272 2.7023 7.8671 7.8638 c 0.0895 2.0243 0.1087 2.6287 0.1087 7.752 s -0.0192 5.7308 -0.1087 7.752 c -0.2399 5.1583 -2.6608 7.6304 -7.8671 7.8671 c -2.0243 0.0895 -2.6287 0.112 -7.7551 0.112 c -5.1232 0 -5.7308 -0.0192 -7.752 -0.112 c -5.2127 -0.2399 -7.6272 -2.7151 -7.8671 -7.8671 c -0.0895 -2.0212 -0.112 -2.6287 -0.112 -7.752 s 0.0224 -5.7308 0.112 -7.752 c 0.2366 -5.1648 2.6608 -7.6304 7.8671 -7.8671 c 2.0212 -0.0928 2.6287 -0.1087 7.752 -0.1087 z m 0 -3.4602 c -5.2127 0 -5.8619 0.0224 -7.9118 0.1183 c -6.9716 0.3198 -10.8412 4.1862 -11.1611 11.1578 c -0.0928 2.05 -0.1151 2.7023 -0.1151 7.9118 c 0 5.2127 0.0224 5.8651 0.1151 7.9118 c 0.3198 6.9684 4.1893 10.8412 11.1611 11.1611 c 2.05 0.0928 2.6992 0.1151 7.9118 0.1151 c 5.2127 0 5.8651 -0.0224 7.9151 -0.1151 c 6.9588 -0.3198 10.8444 -4.1862 11.1578 -11.1611 c 0.0928 -2.0467 0.1151 -2.6992 0.1151 -7.9118 c 0 -5.2096 -0.0224 -5.8619 -0.1151 -7.9118 c -0.3134 -6.962 -4.1862 -10.8412 -11.1578 -11.1578 c -2.05 -0.0959 -2.7023 -0.1183 -7.9151 -0.1183 z m 0 9.3349 c -5.4398 0 -9.8531 4.41 -9.8531 9.8531 s 4.4132 9.8531 9.8531 9.8531 s 9.8531 -4.41 9.8531 -9.8531 c 0 -5.4398 -4.4132 -9.8531 -9.8531 -9.8531 z m 0 16.2491 c -3.5338 0 -6.396 -2.8622 -6.396 -6.396 c 0 -3.5306 2.8622 -6.396 6.396 -6.396 c 3.5306 0 6.3992 2.8622 6.3992 6.396 s -2.8686 6.396 -6.3992 6.396 z m 10.24 -18.9385 c -1.2696 0 -2.3026 1.0297 -2.3026 2.3026 c 0 1.2696 1.0297 2.3026 2.3026 2.3026 c 1.2728 0 2.3058 -1.0297 2.3058 -2.3026 c 0 -1.2728 -1.0297 -2.3026 -2.3058 -2.3026 z"
    />
  </svg>
);

export function SharingButtons() {
  const intl = useIntl();

  const url = window.location.origin + window.location.pathname;
  const linkedInUrl = url + '?utm_source=linkedin&utm_medium=iqc_landing';
  const facebookUrl = url + '?utm_source=facebook&utm_medium=iqc_landing';

  return (
    <div className="iqcSharingButtons__container">
      <LinkedinShareButton
        url={linkedInUrl}
        title={formatMessageHelper(intl, 'iqc.share.linkedinTitle')}
        summary={formatMessageHelper(intl, 'iqc.share.linkedinSummary')}
        source={formatMessageHelper(intl, 'iqc.share.linkedinSource')}
      >
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>

      <FacebookShareButton
        url={facebookUrl}
        quote={formatMessageHelper(intl, 'iqc.share.facebookHashtag')}
        hashtag={formatMessageHelper(intl, 'iqc.share.facebookHashtag')}
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <a href={INSTAGRAM_REEL_URL} target="_blank" rel="noreferrer">
        <InstagramIcon />
      </a>
    </div>
  );
}
